import React from 'react';
import {
  List, ListItem, ListItemText, IconButton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export default function FileList({ files, onRemove }) {
  return (
    <List>
      {files.map((file, i) => (
        <ListItem
          key={i}
          sx={{
            bgcolor: 'background.secondary',
            borderRadius: 1,
            mb: 1,
            boxShadow: 1,
            py: 0.2
          }}
          secondaryAction={
            <IconButton edge="end" onClick={() => onRemove(i)}>
              <DeleteIcon color="secondary" />
            </IconButton>
          }
        >
          <ListItemText
            primary={file.name}
            secondary={`${(file.size / 1024 / 1024).toFixed(2)} MB`}
          />
        </ListItem>
      ))}
    </List>
  );
}